<template>
  <div :class="bem.b()" :style="{ backgroundColor: background }">
    <div :class="bem.m('white')" />
    <div :class="bem.m('black')" />
    <div
      :class="bem.m('cursor')"
      :style="{
        top: cursorTop + 'px',
        left: cursorLeft + 'px'
      }"
    >
      <div></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, getCurrentInstance, onMounted } from 'vue'
import draggable from '../config/draggable'
import { svPanelProps } from '../config'
import { createNamespace } from '@ll-plus/utils'

// Config
defineOptions({ name: 'SvPanel' })
const props = defineProps(svPanelProps)
const bem = createNamespace('sv-panel')

// Data
const instance = getCurrentInstance()
const cursorTop = ref(0)
const cursorLeft = ref(0)
const background = ref('hsl(0, 100%, 50%)')
const colorValue = computed(() => {
  const hue = props.color?.get('hue')
  const value = props.color?.get('value')
  return { hue, value }
})
// Methods

const update = () => {
  const saturation = props.color?.get('saturation')
  const value = props.color?.get('value')

  const ele = instance?.vnode.el as HTMLElement

  cursorLeft.value = (saturation * ele.clientWidth) / 100
  cursorTop.value = ((100 - value) * ele.clientHeight) / 100

  background.value = `hsl(${props.color?.get('hue')}, 100%, 50%)`
}
const handleDrag = (event: MouseEvent) => {
  const ele = instance?.vnode.el as HTMLElement
  const rect = ele.getBoundingClientRect()

  let left = event.clientX - rect.left
  let top = event.clientY - rect.top

  left = Math.max(0, left)
  left = Math.min(left, rect.width)
  top = Math.max(0, top)
  top = Math.min(top, rect.height)

  cursorLeft.value = left
  cursorTop.value = top

  props.color?.set({
    saturation: (left / rect.width) * 100,
    value: 100 - (top / rect.height) * 100
  })
}
// Watch
watch(
  () => colorValue.value,
  () => {
    update()
  }
)

onMounted(() => {
  const ele = instance?.vnode.el as HTMLElement
  draggable(ele, {
    drag: event => {
      handleDrag(event)
    },
    end: event => {
      handleDrag(event)
    }
  })
})

defineExpose({ update })
</script>
